import React from "react";
import { VideoStore } from "../store/VideoStore";
import { VideoStoreContext } from "../context/VideoContext";

export const VideoStoreProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const store = React.useRef(new VideoStore()).current;
    return (
        <VideoStoreContext.Provider value={store}>
            {children}
        </VideoStoreContext.Provider>
    );
};
